// PA Score component progress bar. Rendered three times per leg
// (Historical Value / Recent Form / Market Price). Preserves the
// "Exact-line comparison not available" caption + testid variant.
export function ScoreBar({ label, value, max, testid, unavailable }) {
  const numeric = typeof value === "number";
  const pct = numeric ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div>
      <div className="flex items-baseline justify-between">
        <dt className="text-[11px] uppercase tracking-wide text-slate-500 font-display">
          {label}
        </dt>
        <dd
          className="text-slate-900 text-sm font-mono-num"
          data-testid={testid}
        >
          {numeric
            ? `${value.toFixed(1)} / ${max}`
            : unavailable
              ? "Unavailable"
              : `— / ${max}`}
        </dd>
      </div>
      <div className="mt-1.5 h-1.5 bg-slate-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full"
          style={{
            width: `${pct}%`,
            backgroundColor: numeric ? "#059669" : "#cbd5e1",
            transition: "width 300ms ease-out",
          }}
        />
      </div>
      {!numeric && unavailable && (
        <p
          className="mt-1 text-[10px] text-slate-500"
          data-testid={`${testid}-unavailable`}
        >
          Exact-line comparison not available
        </p>
      )}
    </div>
  );
}
